import { GetDoc, GetWSMgr } from "@/Utils/StateLib";
import {
  BOX_ACTIONS,
  enumObjClassNames,
  enumOverrideType,
  kDesiredHolders,
  kPositionStatus
} from "@coreapp/constants";
import { QObjDBObject } from "@coreapp/CoreApp/QObjDBObject";

export const promptToReopenPosition = async (dataObjects: QObjDBObject[]) => {
  const wsMgr = GetWSMgr();
  if (!wsMgr) {
    return;
  }

  const planMgr = wsMgr.GetPlanMgr();
  if (!planMgr) {
    return;
  }

  const doc = GetDoc();
  const objDb = doc?.GetObjDB();
  if (!objDb) {
    return;
  }

  const objClass = objDb.GetClassByName(enumObjClassNames.position);
  const initChanges: Record<string, any> = {};
  for (const fieldID of [kPositionStatus, kDesiredHolders]) {
    const fieldDef = objClass?.GetFieldDefByID(fieldID);
    const fieldName = fieldDef?.GetFieldName();
    switch (fieldID) {
      case kDesiredHolders:
        initChanges[fieldName] = 1;
        break;
      case kPositionStatus:
        initChanges[fieldName] = "Active";
        break;
    }
  }

  const changeType = enumOverrideType.change;
  const action = BOX_ACTIONS.REOPEN;

  if (dataObjects.length === 1) {
    planMgr.HandleEditModalOpen(dataObjects[0], changeType, initChanges, action);
    return;
  }
  planMgr.HandleEditMultiModalOpen(dataObjects, changeType, initChanges, action);
};
